
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";
import { ElForm } from "element-ui/types/form";
import api from "@/api";
import {
  GetUserForEditOutput,
  CreateOrUpdateUserInput,
  UserRoleDto, UserBabyDetail
} from "@/api/appService";

import { checkPermission, checkRole } from "@/utils/permission";

@Component
export default class EditUser extends Vue {


  @Prop({required:true,default:false})
  show!:boolean;

  internalShow = false;
  loading = true

  get dialogTitle() {
    return this.form!.user!.id ? "编辑" : "新建";
  }

  private checkPermission = checkPermission;
  private checkRole = checkRole;

  roles: UserRoleDto[] = [];

  defaultData: CreateOrUpdateUserInput = {
    user: { id: 0, babyDetail: {realname:''} },
    assignedRoleNames: []
  };


  form: CreateOrUpdateUserInput = { ...this.defaultData };

  get baby():UserBabyDetail{
    if(this.form.user?.babyDetail) {
      return this.form.user.babyDetail;
    } else {
      this.form.user!.babyDetail = {}
      return this.form.user!.babyDetail;
    }
  }

  @Watch('internalShow')
  onInternalShowChange(value:boolean){
    this.$emit('update:show', value)
  }

  @Watch("show")
  async onShowChange(value: boolean) {
    this.internalShow = value;
    if (value) {
      await this.getUserForEdit();
    } else {
      this.form = { ...this.defaultData };
    }


    this.$nextTick(() => {
      debugger
      (this.$refs.dataForm as ElForm).clearValidate()
    });
  }

  async getUserForEdit(){
    this.loading = true;
    await api.user.getUserForEdit({ id: this.form!.user!.id }).then(res => {
      this.loading = false;
      this.form.user = {babyDetail:{}, ...res.user};
      this.roles = res.roles!;
      this.form!.assignedRoleNames = [];
      if (res.roles)
        res.roles.forEach((z: any) => {
          if (z.isAssigned) {
            this.form!.assignedRoleNames!.push(z.roleName);
          }
        });
    });
  }



  async save() {
    console.log(this.form);
    (this.$refs.dataForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        if (this.form!.user!.id) {
          await api.user.createOrUpdateUser({ body: this.form });
        } else {
          await api.user.createOrUpdateUser({ body: this.form });
        }
        this.show = false;
        this.$message.success("更新成功");
        this.closeDialog()
        this.$emit("onSave");
      }
    });
  }

  // 图片上传前判断
  async beforeAvatarUpload(file: any) {
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 2MB!");
    }
    return isLt2M;
  }

  async handleAvatarSuccess(res: any, file: any) {
    console.log(res);
    if (res.success) {
      this.form!.user!.headImgUrl = res.result;
    }
  }

  cancel() {
    this.closeDialog();
  }

  private closeDialog(){
    this.$emit('update:show',false)
  }

  private async handleSelect(e: any) {
    console.log(e);
    this.form!.user!.babyDetail!.lat = e.lat;
    this.form!.user!.babyDetail!.lng = e.lng;
  }

  private async querySearch(queryString: string, callback: Function) {
    api.client.getPlaceSuggestion({ query: queryString }).then(res => {
      const list: any[] = res.map(x=> {
        return {value:`${x.district} ${x.name}`,address:x.name,...x}
      });

      console.log(list);
      callback(list);
    });
  }

  roleRule = {
    name: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ]
  };
}
